module.exports = __webpack_public_path__ + "static/media/icon-lighting.f205de65.svg";